export const getCauseCategoriesList = (t, selected) => {
  const fullList = [
    { value: 'Imbalance', label: t('Imbalance') },
    { value: 'Misalignment', label: t('Misalignment') },
    { value: 'Structural looseness', label: t('Structural looseness') },
    { value: 'Rotating (bearing) looseness', label: t('Rotating (bearing) looseness') },
    { value: 'Belt tracking', label: t('Belt tracking') },
    { value: 'Belt tension', label: t('Belt tension') },
    { value: 'Belt wear', label: t('Belt wear') },
    { value: 'Bearing defects', label: t('Bearing defects') },
    { value: 'Lubrication', label: t('Lubrication') },
    { value: 'Installation/Workmanship', label: t('Installation/Workmanship') },
    { value: 'Temperature', label: t('Temperature') },
    { value: 'Other', label: t('Other') },
  ];

  if (!selected) {
    return {
      causeCategoriesList: fullList,
      listLength: fullList.length,
    };
  }

  return {
    causeCategoriesList: fullList.filter(
      (item) => !selected.find((el) => el.cause_category?.value === item.value),
    ),
    listLength: fullList.length,
  };
};
